const addUploadCapabilities = (repository: any) => {
  const _create = repository.create;
  repository.create = (data: any, _options: any) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => formData.append(key, data[key]));
    return _create(formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
  const _update = repository.update;
  repository.update = (data: any, _options: any) => {
    const formData: any = new FormData();
    if (data.id) {
      formData.id = data.id;
    }
    Object.keys(data).forEach((key) => formData.append(key, data[key]));
    return _update(formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
};

export default addUploadCapabilities;
